import { ChevronUp, ChevronRight, ChevronDown, ChevronLeft } from 'lucide-react';
import type { OutpaintDirection } from '../hooks/useOutpainting';

interface EdgeExpandButtonsProps {
  onExpand: (direction: OutpaintDirection) => void;
  visible: boolean;
}

const BUTTONS: Array<{ dir: OutpaintDirection; Icon: typeof ChevronUp; position: string }> = [
  { dir: 'top', Icon: ChevronUp, position: 'top-2 left-1/2 -translate-x-1/2' },
  { dir: 'right', Icon: ChevronRight, position: 'right-2 top-1/2 -translate-y-1/2' },
  { dir: 'bottom', Icon: ChevronDown, position: 'bottom-2 left-1/2 -translate-x-1/2' },
  { dir: 'left', Icon: ChevronLeft, position: 'left-2 top-1/2 -translate-y-1/2' },
];

export default function EdgeExpandButtons({ onExpand, visible }: EdgeExpandButtonsProps) {
  if (!visible) return null;

  return (
    <>
      {BUTTONS.map(({ dir, Icon, position }) => (
        <button
          key={dir}
          type="button"
          className={`absolute ${position} z-30 w-12 h-12 flex items-center justify-center bg-black/60 rounded hover:bg-blue-500/80 text-white transition-colors`}
          onClick={() => onExpand(dir)}
          title={`Expand ${dir}`}
        >
          <Icon size={24} />
        </button>
      ))}
    </>
  );
}
